export default {
  name: "RowItem"
};